//@flow
type ActionReturnType = {
    type: string,
    payload?: any
};

export class ChatActions {
    static CONNECT_CHAT_SDK: string = 'CONNECT_CHAT_SDK';
    static DISCONNECT_CHAT_SDK: string = 'DISCONNECT_CHAT_SDK';
    static SHOW_CHAT_WINDOW: string = 'SHOW_CHAT_WINDOW';
    static HIDE_CHAT_WINDOW: string = 'HIDE_CHAT_WINDOW';
    static SET_USER_PROFILE: string = 'SET_USER_PROFILE';
    static SET_UNREAD_CHANNEL_COUNT: string = 'SET_UNREAD_CHANNEL_COUNT';

    static showChatWindow(): ActionReturnType {
        return {
            type: ChatActions.SHOW_CHAT_WINDOW
        };
    }
    static hideChatWindow(): ActionReturnType {
        return {
            type: ChatActions.HIDE_CHAT_WINDOW
        };
    }
    static markConnected(): ActionReturnType {
        return {
            type: ChatActions.CONNECT_CHAT_SDK
        };
    }
    static markDisconnected(): ActionReturnType {
        return {
            type: ChatActions.DISCONNECT_CHAT_SDK
        };
    }
    static setUserProfile(userProfile: any): ActionReturnType {
        return {
            type: ChatActions.SET_USER_PROFILE,
            payload: userProfile
        };
    }
    static setUnreadChannelCount(channelCount: number): ActionReturnType {
        return {
            type: ChatActions.SET_UNREAD_CHANNEL_COUNT,
            payload: channelCount
        };
    }
}
